import { LocalPage } from "./ServiceDetail";
import { AREA_PAGES, SERVICE_PAGES_ES, AREA_PAGES_ES } from "../lib/localPages";

export function AreaPage() {
  return <LocalPage pages={AREA_PAGES} lang="en" section="areas" />;
}

export function ServicePageEs() {
  return <LocalPage pages={SERVICE_PAGES_ES} lang="es" section="services" />;
}

export function AreaPageEs() {
  return <LocalPage pages={AREA_PAGES_ES} lang="es" section="areas" />;
}
